/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import moment from 'moment'
import * as Yup from 'yup'

import { FiArrowRightCircle, FiClock, FiDollarSign } from 'react-icons/fi'
import { BiCake } from 'react-icons/bi'
import getValidationErrors from '../../utils/getValidationErrors'
import usePersistedState from '../../hooks/usePersistedState'
import { ValorMascarar } from '../../utils/masks'
import { formatValue } from '../../utils/formatValues'

import Header from '../../components/Header'
import Button from '../../components/Button'
import Input from '../../components/Input'

import { UserDetails, UserData } from '../../utils/interfaces'
import { Content, InfoContent, UPContentSlider, UPBoxSlider } from './styles'
import calculaIdade from '../../utils/calculaIdade'
import InputRange from '../../components/InputRange'
import Line from '../../components/Line'
import Container from '../../components/Container'

const Contribution: React.FC = () => {
  const [userDetails, setUserDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )
  const [userData, setUserData] = usePersistedState<UserData>(
    'userData',
    {} as UserData,
  )
  const [idadeApos, setIdadeApos] = useState(userDetails.age)
  const [salarioValue, setSalarioValue] = useState(userDetails.salario)
  const [vlrCtbBasica, setVlrCtbBasica] = useState(
    userDetails.contribuicaoBasica > 0 ? userDetails.contribuicaoBasica : 0,
  )
  const [vlrCtbPatrocinadora, setVlrCtbPatrocinadora] = useState(
    userDetails.contribuicaoPatrocinadora > 0
      ? userDetails.contribuicaoPatrocinadora
      : 0,
  )
  const [vlrCtbTotal, setVlrCtbTotal] = useState(
    userDetails.contribuicaoBasica + userDetails.contribuicaoPatrocinadora > 0
      ? userDetails.contribuicaoBasica + userDetails.contribuicaoPatrocinadora
      : 0,
  )
  const [pctCtbBas, setPctCtbBas] = useState(
    userDetails.pctContribuicaoBasica > 0
      ? userDetails.pctContribuicaoBasica
      : 6,
  )
  const [pctCtbSup, setPctCtbSup] = useState(
    userDetails.pctContribuicaoSuplementar > 0
      ? userDetails.pctContribuicaoSuplementar
      : 0,
  )
  const [vlrCtbSup, setVlrCtbSup] = useState(
    userDetails.contribuicaoSuplementar > 0
      ? userDetails.contribuicaoSuplementar
      : 0,
  )
  const UAMB = 577.369
  const history = useHistory()
  const formRef = useRef<FormHandles>(null)

  /* CALCULO DE CONTRIBUIÇÃO NORMAL */
  let pctCtb = 0
  const maxUamb = UAMB * 10
  let contribExcedente = 0
  let modelContrib = 0
  useEffect(() => {
    if (salarioValue !== 0 && salarioValue !== undefined) {
      if (salarioValue <= maxUamb) {
        pctCtb = 0.005
        modelContrib = salarioValue * pctCtb

        setPctCtbBas(pctCtb * 100)
        setVlrCtbBasica(parseFloat(modelContrib.toFixed(2)))
        setVlrCtbPatrocinadora(parseFloat(modelContrib.toFixed(2)))
      } else {
        pctCtb = 0.09
        contribExcedente = salarioValue - maxUamb
        modelContrib = maxUamb * 0.005 + contribExcedente * 0.09

        setPctCtbBas((modelContrib / salarioValue) * 100)
        setVlrCtbBasica(parseFloat(modelContrib.toFixed(2)))
        setVlrCtbPatrocinadora(parseFloat(modelContrib.toFixed(2)))
      }
    }

    setVlrCtbTotal(parseFloat((modelContrib * 2).toFixed(2)))
  }, [
    salarioValue,
    vlrCtbPatrocinadora,
    vlrCtbBasica,
    setVlrCtbBasica,
    setVlrCtbPatrocinadora,
  ])

  const mudarSalario = useCallback(
    valor => {
      const v = valor.replace(',', '').replaceAll('.', '')
      if (isNaN(v)) {
        setSalarioValue(salarioValue)
      } else {
        const m = Math.floor(v.length - 2)
        const a = `${v.substr(0, m)}.${v.substr(m)}`
        const f = parseFloat(a)
        setSalarioValue(f)
        // handleCalculaContribuicao(f)
      }
    },
    [salarioValue, pctCtbSup],
  )

  const handleMudaContribSup = useCallback(
    valor => {
      const valueCSup = (salarioValue * valor) / 100
      setPctCtbSup(valor)
      setVlrCtbSup(valueCSup)
    },
    [salarioValue],
  )

  const handleChangePctSup = useCallback(
    e => {
      const t = e
      if (isNaN(t)) {
        handleMudaContribSup(0)
      } else {
        handleMudaContribSup(t)
      }
    },
    [handleMudaContribSup],
  )

  const handleSubmit = useCallback(
    async data => {
      try {
        const now = new Date()
        const bday = data.birthdate.split('/').reverse().join('-')
        const ano = bday.split('-')[0]
        const anosContrib2 = idadeApos - (now.getFullYear() - parseInt(ano, 10))
        const idadeMinima =
          calculaIdade(data.birthdate.split('/').reverse().join('-')) < 60
            ? 60
            : calculaIdade(data.birthdate.split('/').reverse().join('-')) + 1

        formRef.current?.setErrors({})

        const schema = Yup.object().shape({
          birthdate: Yup.string()
            .required('Campo obrigatório')
            .test(
              '',
              'A data de nascimento não pode ser maior que hoje.',
              () =>
                moment() >
                  moment(data.birthdate.split('/').reverse().join('-')) ||
                data.birthdate === '',
            )
            .test(
              '',
              'Data de nascimento inválida',
              () =>
                moment(
                  data.birthdate.split('/').reverse().join('-'),
                ).isValid() || data.birthdate === '',
            )
            .test(
              '',
              'Data de nascimento inválida',
              () =>
                calculaIdade(data.birthdate.split('/').reverse().join('-')) <=
                  115 || data.birthdate === '',
            ),
          age: Yup.number()
            .typeError(
              'Digite a idade desejada para a aposentadoria para realizar a simulação',
            )
            .required(
              'Digite a idade desejada para a aposentadoria para realizar a simulação',
            )
            .min(
              idadeMinima,
              `Idade inválida. Por favor, escolha uma idade igual ou superior a ${idadeMinima} anos`,
            )
            .max(115, 'Idade inválida.'),
          salario: Yup.string()
            .test('', 'Salário inválido.', () => salarioValue <= 100000)
            .required('Campo obrigatório'),
          pctContribuicaoSup: Yup.number().test(
            '',
            'Percentual inválido. Escolha no máximo 100%',
            () => pctCtbSup <= 100,
          ),
        })

        await schema.validate(data, { abortEarly: false })

        setUserData({
          ...userData,
          birthdate: bday,
        })

        setUserDetails({
          ...userDetails,
          salario: salarioValue,
          contribuicaoBasica: vlrCtbBasica,
          contribuicaoPatrocinadora: vlrCtbPatrocinadora,
          pctContribuicaoBasica: pctCtbBas,
          contribuicaoSuplementar: vlrCtbSup,
          pctContribuicaoSuplementar: pctCtbSup * 1,
          years: anosContrib2,
          age: idadeApos,
        })

        history.push('/simulation')
      } catch (err) {
        formRef.current?.setErrors(
          getValidationErrors(err as Yup.ValidationError),
        )
      }
    },
    [
      history,
      idadeApos,
      pctCtbSup,
      salarioValue,
      setUserData,
      setUserDetails,
      userData,
      userDetails,
      vlrCtbBasica,
      vlrCtbPatrocinadora,
      vlrCtbSup,
    ],
  )

  const marksSup = []
  marksSup.push({
    value: 0,
    label: '0%',
  })
  for (let i = 5; i <= 50; i += 5) {
    marksSup.push({
      value: i,
      label: Math.floor(i) === i ? `${i.toString().replace('.', ',')}%` : '',
    })
  }

  const handleClick = useCallback(() => {
    formRef.current?.submitForm()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          initialData={{
            age: userDetails.age,
            salario:
              userDetails.salario === undefined
                ? ''
                : ValorMascarar(userDetails.salario.toFixed(2).toString()),
            birthdate:
              userData.birthdate === undefined
                ? ''
                : userData.birthdate.toString().split('-').reverse().join('/'),
            pctContribuicaoSup: pctCtbSup,
          }}
        >
          <Content>
            <strong>Simulação de Contribuição</strong>
            <p>
              Será descontada mensalmente de sua folha de pagamento. A empresa
              também fará a contribuição no mesmo valor.
              <br /> Para isso, defina a porcentagem de desconto sobre o seu
              salário e simule sua contribuição mensal.
            </p>
            <Input
              icon={BiCake}
              name="birthdate"
              placeholder="Data de nascimento"
              mask="date"
            />
            <Input
              icon={FiClock}
              type="number"
              name="age"
              value={idadeApos}
              min={50}
              sufix="anos"
              placeholder="Qual a idade desejada para a aposentadoria?"
              onChange={e => setIdadeApos(parseInt(e.target.value, 10))}
            />
            <Input
              icon={FiDollarSign}
              name="salario"
              mask="currency"
              type="text"
              placeholder="Qual o seu salário (R$)?"
              onChange={e => mudarSalario(e.target.value)}
            />
          </Content>
          <Content>
            <strong>Contribuição básica</strong>
            <InfoContent>
              <div>
                <p>Valor da contribuição básica do participante: </p>
                <strong>{formatValue(vlrCtbBasica)}</strong>
              </div>
              <div>
                <p>Contrapartida da patrocinadora: </p>
                <strong>{formatValue(vlrCtbPatrocinadora)}</strong>
              </div>
              <Line />
              <div>
                <div>
                  <p>Valor total de contribuição básica ao plano: </p>
                  <small>(participante + patrocinadora)</small>
                </div>
                <strong>{formatValue(vlrCtbTotal)}</strong>
              </div>
            </InfoContent>
          </Content>
          <Content>
            <strong>Contribuição voluntária</strong>
            <UPContentSlider>
              <div className="UR-info">
                <p>
                  Com qual % sobre o seu salário você deseja contribuir
                  adicionalmente?
                </p>
              </div>
              <UPBoxSlider>
                <InputRange
                  name="rangeContribSuplementar"
                  functionChange={e => handleChangePctSup(e)}
                  start={0}
                  end={50}
                  initialValue={pctCtbSup}
                  step={0.1}
                  key={0}
                  marks={marksSup}
                  valueLabelDisplay="off"
                />
                <strong>{pctCtbSup}%</strong>
              </UPBoxSlider>
              <Line />
              <InfoContent>
                <div>
                  <p>Valor da contribuição voluntária:</p>
                  <strong>{formatValue(vlrCtbSup)}</strong>
                </div>
              </InfoContent>
            </UPContentSlider>
          </Content>

          <Content>
            <InfoContent>
              <div>
                <div>
                  <h3>Valor total que será descontado em folha:</h3>
                  <small>Contribuição básica + voluntária</small>
                </div>
                <strong>{formatValue(vlrCtbBasica + vlrCtbSup)}</strong>
              </div>
            </InfoContent>
          </Content>
        </Form>

        <Button color="blue" onClick={handleClick} width="large">
          Simular valores
        </Button>
      </Container>
    </>
  )
}

export default Contribution
